import { AxiosInstance } from 'axios'

export type City = {
  id: number
  name: string
  state: string
  stateId: number
  uf: string
}

export function addressEndpoints(apiClient: AxiosInstance) {
  return {
    async searchCity(search: string, limit: number = 10): Promise<City[]> {
      let city = search ?? ''

      let state = ''
      if (typeof search === 'string' && search.includes('/')) {
        city = search.split('/')[0]
        state = search.split('/')[1]
      }

      return apiClient.get(`search-city/${city}`, {
        params: {
          state,
          limit,
        },
      })
    },
  }
}
